export default "__VITE_ASSET__BRiBpjVM__"